type EventNormalizationImportFileValidation =
  | { valid: true; extension: ".csv" | ".tsv" }
  | {
      valid: false;
      extension: string | null;
      reason: "missingExtension" | "unsupportedExtension" | "fileTooLarge";
    };

export function validateEventNormalizationImportFile(
  file: Pick<File, "name" | "size">,
  maxFileSizeBytes: number,
): EventNormalizationImportFileValidation {
  const extensionStart = file.name.lastIndexOf(".");
  if (extensionStart <= 0 || extensionStart === file.name.length - 1) {
    return { valid: false, extension: null, reason: "missingExtension" };
  }

  const extension = file.name.slice(extensionStart).toLowerCase();
  if (extension !== ".csv" && extension !== ".tsv") {
    return { valid: false, extension, reason: "unsupportedExtension" };
  }

  if (file.size > maxFileSizeBytes) {
    return { valid: false, extension, reason: "fileTooLarge" };
  }

  return { valid: true, extension };
}
